export default __webpack_public_path__ + "static/media/logo.68c0cb47.png";